export default {
    ai: {
        title: 'Create image using AI',
    },
};
